<template>
  <div class="companyOverviewDetail">
    <div class="sideBox">
      <h1 class="title">{{ newObj.title }}</h1>
      <div class="time">{{ newObj.time }}</div>
      <div class="contentBox">
        <img class="imgBox" :src="newObj.img" alt="" />
        <p class="text" v-for="(item, index) in newObj.content" :key="index">
          {{ item }}
        </p>
      </div>
    </div>

    <el-backtop></el-backtop>
  </div>
</template>

<script>
// import { newDetailObj } from '@/static/newsDetail.js'
export default {
  data () {
    return {
      newDetailObj: {},
      newObj: {}
    }
  },
  created () {
    this.newDetailObj = JSON.parse(
      window.sessionStorage.getItem('newDetailObj')
    )
  },
  mounted () {
    this.newObj = this.newDetailObj[this.$route.query.id]
  }
}
</script>

<style scoped lang="less">
.companyOverviewDetail {
  width: 100%;
  background-color: #f6f6f6;
  .sideBox {
    width: 1150px;
    margin: 0 auto;
    .title {
      font-weight: 700;
      font-size: 40px;
      padding-top: 20px;
    }
    .time {
      font-size: 30px;
      color: #7f7f7f;
      margin: 40px 0;
    }
    .contentBox {
      padding: 0 100px;
      .imgBox {
        width: 100%;
        margin-bottom: 20px;
      }
      .text {
        margin-bottom: 20px;
        font-size: 24px;
        color: #333333;
      }
    }
  }

  //当屏幕最小宽度为1300px
  @media screen and (min-width: 1300px) {
    .sideBox {
      transition: width 0.3s ease-in-out;
    }
  }
  //当屏幕宽度 最小为1000px 最大为1300px时
  @media screen and (min-width: 1000px) and (max-width: 1300px) {
    .sideBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
      .contentBox {
        padding: 0 80px;
      }
    }
  }
  //当屏幕宽度 最小为800px 最大为1000px时
  @media screen and (min-width: 800px) and (max-width: 1000px) {
    .sideBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
      .contentBox {
        padding: 0 60px;
      }
    }
  }
  //当屏幕最大宽度为800px
  @media screen and (max-width: 800px) {
    .sideBox {
      width: 90%;
      transition: width 0.3s ease-in-out;
      .title {
        font-size: 20px;
      }
      .time {
        font-size: 20px;
      }
      .contentBox {
        padding: 0 20px;
        .text {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
